export default __webpack_public_path__ + "static/media/Sefi.7b4f6385.png";